<template>
  <markdown class="MediaGridItemDescription t-text-sm"
    v-if="data.description"
    :content="data.description" />
</template>

<script>
export default {
  name: 'MediaGridItemDescription',

  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
@import 'properties';

.MediaGridItemTitle + .MediaGridItemDescription {
  margin-top: var(--unit-025);
}

.MediaGridItemDescription {

}
</style>



// WEBPACK FOOTER //
// MediaGridItemDescription.vue?66bb4b66